import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class CashAccountInventoryInvoiceDetailDTO  {
    _originalTypeClassName = "zERP.BO.CashAccountInventoryInvoiceDetailDTO";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
CashAccountInventoryInvoiceDetailDTO.translate = translateService;
}
this.DateIssued = null;
this.CashAccountInventoryInvoiceDetailDTOKey = null;
this._key = this.CashAccountInventoryInvoiceDetailDTOKey = 0; 
}

static translate: TranslateService;
_key: any;
DateIssued:any;
CashAccountInventoryInvoiceDetail:any;
private _CashAccountInventoryInvoiceDetailDTOKey:any;
get CashAccountInventoryInvoiceDetailDTOKey(): any {
    return this._CashAccountInventoryInvoiceDetailDTOKey;
  }
set CashAccountInventoryInvoiceDetailDTOKey(value: any) {
    this._CashAccountInventoryInvoiceDetailDTOKey = value;
    this._key = value;
  }
static setCashAccountInventoryInvoiceDetail = ($this, value) => {
var oldValue = $this.CashAccountInventoryInvoiceDetail;
$this.CashAccountInventoryInvoiceDetail = value;
if (value != null) {
}
}


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.CashAccountInventoryInvoiceDetailDTOKey == null || $this.CashAccountInventoryInvoiceDetailDTOKey == 0;
            }


}